export default function referralsApi(fetch, baseUrl) {
  return {
    fetchCampaigns({ pageNo = 0, pageSize = 10 }) {
      return fetch(
        `${baseUrl}/admin?template=PLATFORM_CAMPAIGNS&limit=${pageSize}&offset=${pageNo * pageSize}`
      );
    },

    campaignByReferralCode(code) {
      return fetch(`${baseUrl}/${code}`);
    }
  };
}
